<template>
  <form class="sign-up-confirm-phone" @submit.prevent="handlerSubmit">
    <SignBanner result="register" />
    <ModalComponentBody>
      <SignTitle>
        {{ messages?.register }}
      </SignTitle>
      <SignText> {{ messages.createAnAccount }} </SignText>
      <p class="sign-up-confirm-phone__text">
        {{ messages.weSentSmsOnNumber }}
      </p>
      <div class="confirm-phone">
        <p class="confirm-phone-number">{{ getPhoneNumber }}</p>
        <button type="button" class="confirm-phone-return" @click="handlerMistake">
          <svg viewBox="0 0 20 20" class="confirm-phone-return__icon">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.9722 3.35026C14.7228 3.35026 14.4836 3.44933 14.3073 3.62567L13.327 4.60592L14.6578 5.93484L15.6371 4.95549C15.8134 4.77915 15.9125 4.53996 15.9125 4.29057C15.9125 4.04119 15.8134 3.80202 15.6371 3.62567C15.4607 3.44933 15.2216 3.35026 14.9722 3.35026ZM13.4734 7.11931L12.1426 5.79035L4.24788 13.6851C4.14836 13.7845 4.07534 13.9076 4.03588 14.0427C4.03586 14.0427 4.03589 14.0426 4.03588 14.0427L3.548 15.7148L5.22006 15.2269C5.35533 15.1875 5.4789 15.1145 5.57852 15.0149L13.4734 7.11931ZM13.1229 2.44125C13.6133 1.95078 14.2786 1.67523 14.9722 1.67523C15.6658 1.67523 16.331 1.95078 16.8215 2.44125C17.312 2.93172 17.5875 3.59694 17.5875 4.29057C17.5875 4.9842 17.312 5.64942 16.8215 6.13989L6.76297 16.1993C6.4642 16.498 6.09488 16.7167 5.68924 16.8349C5.6891 16.8349 5.68938 16.8348 5.68924 16.8349L3.2839 17.5367C3.06769 17.5998 2.83843 17.6036 2.62027 17.5477C2.40212 17.4918 2.20299 17.3783 2.04374 17.219C1.88449 17.0598 1.77098 16.8606 1.71509 16.6425C1.65919 16.4243 1.66297 16.1951 1.72603 15.9789L2.4279 13.5735C2.54624 13.1682 2.76486 12.7991 3.06346 12.5006C3.0634 12.5007 3.06351 12.5006 3.06346 12.5006L13.1229 2.44125ZM9.21258 16.7503C9.21258 16.2877 9.58755 15.9128 10.0501 15.9128H17.5877C18.0503 15.9128 18.4253 16.2877 18.4253 16.7503C18.4253 17.2128 18.0503 17.5878 17.5877 17.5878H10.0501C9.58755 17.5878 9.21258 17.2128 9.21258 16.7503Z"
            />
          </svg>

          {{ messages.wrongNumber }}
        </button>
      </div>
      <DefInput
        ref="inputCodeComponent"
        v-model="inputValue"
        name="code"
        :placeholder="messages.codeFromSms"
        :is-show-error="Boolean(errorConfirmPhone)"
        inputmode="numeric"
        autocomplete="one-time-code"
        pattern="\d{6}"
        :error-text="errorConfirmPhone"
        autofocus
      />
      <DefButtonPrimary type="submit" :disabled="!isValid">
        {{ messages.btnEnter }}
      </DefButtonPrimary>
      <div v-if="timer > 0" class="confirm-phone-text">
        {{ messages.sendAgainAfter }}
        <span class="confirm-phone-text__counter">{{ timer }} {{ messages.sec }}</span>
      </div>
      <!-- resend message -->
      <button v-else class="resend-message" type="button" @click="handlerResend">
        {{ messages.sendAgain }}
      </button>
    </ModalComponentBody>
  </form>
</template>

<script>
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import useModal from '@use/useModal/useModal';
import SignUp from '@components/Cabinet/Entry/SignUp/SignUp.vue';
import SignBanner from '@components/Cabinet/Entry/SignBanner.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import SignTitle from '@components/Cabinet/Entry/SignTitle.vue';
import SignText from '@components/Cabinet/Entry/SignText.vue';
import Recaptcha3 from '@/utils/Recaptcha3';
import { useResultsStore } from '@/storePinia/stores/results';
import { usePersonalStore } from '@/storePinia/stores/personal';
import Analytics from '@/utils/Analytics/Analytics';
import DefInput from '@components/Def/DefInput/DefInput.vue';

export default {
  name: 'SignUpConfirmPhone',
  components: {
    DefInput,
    SignText,
    SignTitle,
    ModalComponentBody,
    SignBanner,
    DefButtonPrimary,
  },
  props: ['result'],
  data() {
    return {
      timer: 90,
      timeOut: null,
      modal: useModal(),
      isValid: false,
      inputValue: '',
      resultsStore: useResultsStore(),
      personalStore: usePersonalStore(),
    };
  },
  computed: {
    errorConfirmPhone() {
      return this.personalStore.errors?.confirmPhone;
    },
    messages() {
      return this.resultsStore.messages.entry;
    },
    getPhoneNumber() {
      return this.result.formData.get('phone_number');
    },
  },
  watch: {
    inputValue(val) {
      this.isValid = /^\d{6}$/.test(val);
    },
  },
  mounted() {
    this.counter();

    if ('OTPCredential' in window) {
      const ac = new AbortController();

      navigator.credentials
        .get({
          otp: { transport: ['sms'] },
          signal: ac.signal,
        })
        .then((otp) => {
          if (otp && otp.code) {
            this.inputValue = otp.code;
            this.isValid = true;
          }
        })
        .catch(console.error);
    }
  },
  beforeUnmount() {
    clearTimeout(this.timeOut);
  },
  methods: {
    async handlerSubmit({ target }) {
      const formData = new FormData(target);
      const authType = this.result.formData.get('authType');
      const userName = this.result.formData.get('USER_NAME');

      formData.set('phone', this.getPhoneNumber);
      formData.set('authType', authType);
      formData.set('userName', userName);

      await this.personalStore.confirmPhone(formData, (data) => {
        Analytics.signIn(data);
        Analytics.updatedBasket();

        // поставив затримку про всяк випадок щоб аналітика надіслалась.
        setTimeout(() => window.location.reload(), 1000);
      });
    },
    counter() {
      if (this.timer > 0) {
        this.timer -= 1;
        this.timeOut = setTimeout(this.counter, 1000);
      }
    },
    async handlerResend() {
      const { formData } = this.result;

      formData.delete('g-recaptcha-response');
      const token = await Recaptcha3.getSubmitToken();
      formData.append('g-recaptcha-response', token);

      const response = await this.personalStore.signUpByPhone(formData);
      if (response) {
        this.timer = 90;
        this.counter();
      }
    },
    handlerMistake() {
      this.modal.show(
        SignUp,
        {},
        {
          width: '900px',
          backgroundClose: false,
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.sign-up-confirm-phone {
  @include point-md {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  &__text {
    font-weight: 500;
    margin-bottom: 8px;

    font-size: 16px;
    line-height: 125%;
  }
  :deep(.def-input) {
    width: 100%;
  }
  :deep(.def-button-primary) {
    width: 100%;
    margin-top: 8px;
    margin-bottom: 24px;
  }
}
.confirm-phone {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
.confirm-phone-phone {
  font-size: 14px;
  font-weight: 700;
  line-height: 125%;
  @include point-lg {
    font-size: 16px;
  }
}
.confirm-phone-return {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  color: var(--color-golden-browm);
  &__icon {
    width: 20px;
    height: 20px;
    margin-right: 4px;
    fill: currentColor;
  }
}
.resend-message {
  display: block;
  margin: 0 auto;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  text-align: center;
  color: var(--color-golden-browm);
}
.confirm-phone-text {
  color: var(--color-dark-grey);
  font-size: 16px;
  font-weight: 500;
  line-height: 125%;
  text-align: center;
  &__counter {
    color: var(--color-main);
  }
}
//.sign-in-confirm-phone {
//  padding: 40px 16px;
//  @include point-md {
//    padding: 46px 32px;
//  }
//  &__text {
//    font-weight: 500;
//    font-size: rem(14);
//    line-height: 130%;
//    margin-bottom: 8px;
//  }
//  &__resend {
//    margin-bottom: 32px;
//  }
//  &__timer {
//    color: var(--color-dark-grey);
//  }
//  &__mistake {
//    margin-bottom: 24px;
//  }
//  :deep(.def-link) {
//    display: inline-block;
//    color: var(--color-dark-grey);
//    font-size: rem(14);
//  }
//  :deep(.def-button-primary) {
//    width: 100%;
//    margin-top: 24px;
//  }
//}
</style>
